import * as React from 'react';

import LearningPathProductCardImage from 'bundles/product-card/components/LearningPathProductCardImage';
import LearningProductCardImage from 'bundles/product-card/components/LearningProductCardImage';
import type { ImageParams } from 'bundles/product-card/components/LearningProductCardImage';
import { LEARNING_PRODUCTS } from 'bundles/search-common/constants';

type Props = {
  productType?: string | null;
  imageUrl?: string | null;
  imageParams?: ImageParams;
  enableLazyLoading?: boolean;
  enableFluidWidthForLazyImg?: boolean;
  variant?: 'list' | 'grid';
};

/**
 * Picks the preview image treatment for a product card: learning paths get the contained badge
 * treatment, everything else gets the cropped Imgix photo.
 *
 * Centralized because the two collection surfaces -- ProductCardCollection (default display style)
 * and CompactLearningProductCard (spotlight) -- are chosen by a merchandiser's background color, so
 * a per-call-site branch silently diverges the two.
 */
const ProductCardPreviewImage = ({ productType, imageUrl, ...imageProps }: Props) => {
  if (productType === LEARNING_PRODUCTS.LearningPath) {
    return <LearningPathProductCardImage src={imageUrl ?? ''} imageParams={imageProps.imageParams} />;
  }

  return <LearningProductCardImage imageUrl={imageUrl ?? ''} {...imageProps} />;
};

export default ProductCardPreviewImage;
